// "1.234,56" | "1234,56" | "1234.56" | "80" -> centavos inteiros (NaN vira 0).
export function parseBRL(s: string): number {
  const t = s.trim()
  if (!t) return 0
  const normalized = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t
  const n = Number(normalized)
  return Number.isFinite(n) ? Math.round(n * 100) : 0
}

export function centsToInput(c: number): string { return (c / 100).toFixed(2).replace('.', ',') }

// null significa que a pessoa ainda não editou o valor. Apagar ou digitar zero não
// autoriza substituir o que ela escreveu pelo total da fatura.
export function paymentAmountCents(entered: string | null, suggested: number | null): number | null {
  if (suggested === null) return null
  const amount = entered === null ? suggested : parseBRL(entered)
  return Number.isSafeInteger(amount) && amount > 0 ? amount : null
}
